import { render } from "./CardSeventeen.vue?vue&type=template&id=82b2d948"
import script from "./CardSeventeen.vue?vue&type=script&lang=js"
export * from "./CardSeventeen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__